require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-does-shopify-support-barclaycard-epdq.json") })
        }
      }, "path---blog-does-shopify-support-barclaycard-epdq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-does-shopify-support-barclaycard-epdq!./.cache/json/blog-does-shopify-support-barclaycard-epdq.json
// module id = 434
// module chunks = 231608221292675